import { render, staticRenderFns } from "./MsCombobox.vue?vue&type=template&id=b030dede&scoped=true"
import script from "./MsCombobox.vue?vue&type=script&lang=js"
export * from "./MsCombobox.vue?vue&type=script&lang=js"
import style0 from "./MsCombobox.vue?vue&type=style&index=0&id=b030dede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b030dede",
  null
  
)

export default component.exports